export interface HousingCorporationsListResult extends Array<Item> {}

interface Item {
  name: string
  address: string
  comment?: string
  municipality: string
  parentId: string
  ready: boolean
}


export default function createHousingCorporation({post}: any, params: Item): Promise<any> {
  return post(`/housing-corporation`, { corporation: params } , {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/createHousingCorporation.tsx